import styled from "styled-components/macro";
import circles from './assets/background-circles-kpi.svg';

export const ViewStatsWrapper = styled.div`
height: 100vh;
width: calc(100% - 400px); 
background-color: #F3F3F5; 
${props => props.isHidden ? `display: none` : null}; 
@media (min-width: 1480px) {
    width: calc(100% - 480px); 
}
@media (max-width: 992px) {
    display: none; 
}
`

export const BlockWrapper = styled.div`
height: calc(100vh - 110px); 
opacity: 0; 
display: flex; 
align-items: center;
flex-direction: column;
justify-content: center;
animation: fadeIn 1s ease forwards;
animation-delay: .3s;
@keyframes fadeIn {
    0% {
        opacity: 0; 
    }
    100% {
        opacity: 1; 
    }
}
`

export const LargeBlockContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
  margin-top: 25px;
`

export const SmallBlockContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px; 
`

export const LargeBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px; 
  height: 125px; 
  width: 200px; 
  background-color: rgba(31, 34, 55, 1); 
  background-image: url(${circles});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  box-shadow: 4px 8px 16px 0 rgba(0,0,0,0.18);
  @media (min-width: 1600px) {
    height: 156px; 
    width: 250px; 
  }
  p {
    color: white;
  }
`

export const SmallerBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  margin-bottom: 20px;
  box-shadow: 4px 8px 16px 0 rgba(0,0,0,0.18);
  height: 120px;
  width: 200px;
  background-color: ${(props) => props.highlight ? props.theme.colors.highlight : "white"};
  p {
    color: ${(props) => (props.highlight ? 'white' : 'inherit')};
  }

`